export default {
    CustomerList: {
        ChooseCustomer: "Välj Kund",
    },

    Customer: {
        SafesOnline: "Maskiner online",
        CurrentBalance: "Aktuell behållning",
        DailySales: "Försäljning idag",
        ActiveWarnings: "Varningar",
        Of: "AV",
        In: "I",
        Branches: "BUTIKER",
    },

    Branch: {
        ExportTransactions: "Exportera Transaktioner",
        ManageOperators: "Hantera Operatörer",
        ShowOnMap: "Visa på karta",
        CurrentBalance: "Aktuell behållning",
        DailySales: "Försäljning idag",
        MainCurrency: "Huvudvaluta",
        TransactionDays: "Transaktionsdagar"
    },

    BranchList: {
        Name: "Namn",
        Status: "Status",
        BalanceAmount: "Behållning",
        BalanceCurrency: "Valuta",
        LastBalance: "Uppdaterad",
        Branches: "Butiker",
    },

    BranchListFilter: {
        Branches: "Butiker",
        SearchCriteria: "Sök butik...",
    },


    Chart: {
        Sales: "Försäljning",
        Pickup: "Tömning",
        Balance: "Behållning",
        Difference: "Avvikelse",
        Confirmed: "Bekräftade",
        DepositsAndPickups: "Försäljningar och Tömningar",
        NoDataAvailable: "Ingen data tillgänglig",
        SafebagBalance: 'Balans',
        RecyclableBalance: 'Återvinningsbart',
        ManualDepositBalance: 'Manuella depositioner',
        OverflowBalance: 'Overflow'
    },

    ChartDenominations: {
        Deposited: "Deponerade",
        Recyclable: "Återvinningsbara",
        Denominations: "Valörer",
        NoDataAvailable: "Ingen data tillgänglig"
    },

    ChartTransactionDay: {
        ProcessedSales: "Hanterad försäljning in",
        UnprocessedSales: "Ohanterad försäljning in",
        SalesOut: "Försäljning Ut",
        SalesPerHour: "Försäljning per timme"
    },

    CustomerHeader: {
        ShowOnMap: "Visa på kartan",
        Branches: "Butiker",
        Branch: "Butik",
        ExportTransactions: "Transaktioner",
    },

    DeviceStatus: {
        AllOk: "Allt Ok",
    },

    DeviceStatusList: {
        Safes: "Maskiner",
    },

    ExportForm: {
        ExportTransactions: "Exportera Transaktioner",
        Cancel: "Avbryt",
        Export: "Exportera",
        FromDate: "Från",
        Time: "Tid",
        EndDate: "Till"
    },

    ForgotPasswordForm: {
        ForgotHeader: "Glömt ditt lösenord?",
        ForgotText: "Skriv in din mailadress nedan och klicka på knappen. Du kommer att få ett e-mail med vidare instruktioner.",
        LoginLink: "Tillbaka till login",
        EmailAddress: "Mailadress",
        Submit: "Skicka mail",
        ErrorMessage: "Vi kunde inte skicka din begäran till servern"
    },

    LoginPage: {
        LoginHeader: "Välkommen",
        LoginText: "Logga på nedan genom att använda din email och lösenord",
        LoginForgot: "Glömt ditt lösenord?",
        Username: "EMAIL",
        Password: "LÖSENORD",
        Login: "Login"
    },

    ResetPasswordPage: {
        ResetHeader: "Återställ lösenord",
        ResetText: "Skriv in ditt nya lösenord."
    },

    Drawer: {
        Dashboard: "Översikt",
        SwitchCustomer: "Byt Kund",
        MyProfile: "Min Profil",
        Logout: "Logga ut"
    },

    OperatorForm: {
        UserId: "Användar-id",
        FirstName: "Förnamn",
        LastName: "Efternamn",
        Pin: "Pin",
        Save: "Spara",
        Delete: "Ta bort",
        Operator: "Operatör"
    },

    OperatorList: {
        AddOperator: "Lägg till Operatör",
        Operators: "Operatörer",
        Name: "Namn"
    },

    Profile: {
        Profile: "Profil",
        Name: "Namn",
        Language: "Språk",
        Password: "Lösenord",
        ConfirmPassword: "Upprepa Lösenord",
        Update: "Spara"
    },

    ResetPasswordForm: {
        NewPassword: "Nytt Lösenord",
        ConfirmPassword: "Upprepa Lösenord",
        Submit: "Skicka"
    },

    InviteUserForm: {
        InviteHeader: "Användare inbjuden",
        InviteText: "Vänligen fyll i er profil och tryck på spara för att kunna logga in.",
        Name: "Namn",
        Language: "Språk",
        NewPassword: "Nytt Lösenord",
        ConfirmPassword: "Bekräfta Lösenord",
        Submit: "Spara"
    },

    TransactionList: {
        Type: "Typ",
        Operator: "Operatör",
        When: "När",
        Amount: "Belopp",
        Currency: "Valuta",
        Transactions: "Transaktioner",
        Device: "Maskin",
        SalesDay: "SäljDag",
        HoverDeposit: "Försäljning in",
        HoverSalesIn: "Försäljning in",
        HoverSalesOut: "Försäljning ut",
        HoverManualDeposit: "Manuel Deponering",
        HoverCollection: "Tömning",
        HoverCollectionNotes: "Tömning av sedlar",
        HoverCollectionCoins: "Tömning av mynt",
        HoverCollectionEnvelope: "Tömning av manuella deponeringar",
        HoverCollectionOK: "Tömning bekräftad",
        HoverCollectionNotesOK: "Tömning av sedlar bekräftad",
        HoverCollectionCoinsOK: "Tömning av mynt bekräftad",
        HoverCollectionEnvelopeOK: "Tömning av manuel deponering bekräftad",
        HoverCollectionNOK: "Avvikelse tömning",
        HoverCollectionNotesNOK: "Avvikelse tömning av sedlar",
        HoverCollectionCoinsNOK: "Avvikelse tömning av mynt",
        HoverCollectionEnvelopeNOK: "Avvikelse tömning av manuella deponeringar",
        HoverDrain: "Tömning",
        HoverRefill: "Påfyllning",
        HoverExchange: "Växel",
        HoverExchangeIn: "Växel in",
        HoverExchangeOut: "Växel ut",
        HoverCounterfeit: "Falska",
        HoverInternal: "Intern transaktion",
        HoverNOP: "Ingen operation"
    },

    TransactionDayList: {
        Date: "Datum",
        Sales: "Försäljning",
        Pickup: "Hämtning",
        Balance: "Balans",
        TransactionDays: "Transaktionsdagar"
    },

    TransactionDay: {
        Date: "Datum",
        Sales: "Försäljning",
        Pickup: "Hämtning",
        Balance: "Balans",
        TransactionDays: "Transaktionsdagar",
        ExportTransactions: "Exportera Transaktioner"
    },

    TransactionDatePicker: {
        Date: "Datum"
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/sv.js